module.exports = __webpack_public_path__ + "img/album21_18.b85902e4.jpg";